<template>
  <div v-if='hasToc' class='course-toc mb-8 lg:mb-0' v-bind:class="expanded ? 'course-toc--expanded' : 'course-toc--collapsed'">

    <a class='course-toc--expand flex border rounded lg:rounded-l-none border-green-500 border bg-green-500 hover:bg-green-700 hover:border-green-700 text-white mt-2 shadow px-2 py-1 text-green-100 items-center lg:fixed top-0 left-0 lg:mt-16' href='#' @click.prevent='toggleExpand'>
      <minicon icon='graduation-cap-regular' size='8' class='mr-4'></minicon>
      <span class='font-semibold mr-2'>{{course.progress}}%</span>
      <minicon icon='angle-double-right' size='4'></minicon>
    </a>

    <div class='course-toc--content bg-gray-700 p-4 z-100 block top-0 fixed left-0 shadow-lg overflow-scroll'>
      <div>
        <p class='lowercase text-sm text-gray-200 mb-1'>
          Course
          <a class='float-right p-2 hover:bg-gray-100 text-gray-400 hover:text-gray-600 rounded -mt-2' href='#' @click.prevent='toggleExpand'>
            <minicon icon='times-regular' size='4'></minicon>
          </a>
        </p>
      </div>
      <div>
        <p class='text-base text-gray-200 font-semibold'>{{course.name}}</p>
        <p class='text-sm text-gray-400'>{{course.short_description}}</p>
      </div>

      <div class='border-green-400 rounded border my-4 relative'>
        <span class='relative z-30 text-white font-semibold px-2 '>{{course.progress}}% complete</span>
        <span class='z-0 course--progress absolute top-0 left-0 border-green-400 rounded-sm bg-green-400 h-full' :style='progressWidth'></span>
      </div>


      <div class='pt-2'>
        <ol class='list-reset'>
          <li v-for='lesson in course.lessons' v-bind:class="lesson.section && lesson.newSection ? 'mt-4' : ''" :key='lesson.url'>
            <p class='uppercase text-gray-400 text-sm mt-2' v-if='lesson.newSection'>{{lesson.section}}</p>
            <a v-bind:href='lesson.url' class='block toc-lesson px-2 py-1 hover:bg-gray-500 rounded text-gray-300 text-base flex items-center' v-bind:class='[((lesson.position == currentPosition) ? "font-semibold": ""), (lesson.completed ? "toc-lesson--completed" : "toc-lesson--incomplete"), ]'>
              <minicon :icon='lesson.lesson_type' size='4' class='mr-2 text-gray-300' v-tooltip.right='"View this lesson"'></minicon>
              <span class='mr-6 inline-block'>{{lesson.short_title}}</span>
              <minicon icon='check-circle-regular' size='4' v-if='lesson.completed' class='text-green-500 absolute right-0'></minicon>
            </a>
          </li>
        </ol>

        <div class='mt-8' v-if='completed'>
          <div v-if='hasNext()'>
            <p class='text-sm text-gray-400 text-center'>Next Lesson in this Course</p>
            <a class='button button-green button-sm text-sm button-flex' v-bind:href='next.url'>
              {{next.title}}
              <minicon icon='chevron-right-regular' size='4' class='ml-2 text-white'></minicon>
            </a>
          </div>

          <div v-if='user.guest' class='mt-4 text-gray-400'>
            <a class='link-blue-inverse' @click.prevent='showLogin' href='#'>Create a free account</a> to save course progress.
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import Minicon from '~/components/utils/minicon.vue'

export default {
  inject: ['params'],
  data() {
    return {
      style: '',
      sections: []
    }
  },
  components: {
    Minicon
  },
  computed: {
    ...mapFields({
      course: 'userCourse.course' ,
      action: 'post.action',
      completed: 'post.activity.completed',
      expanded: 'app.sidebarExpanded',
      user: 'user'
    }),

    // Find the next article the user should read
    next: function() {
      return this.course.lessons[this.currentIndex+1] || null
    },
    currentIndex: function() {
      let currentLesson = window.location.href
      let foundIndex = null
      this.course.lessons.forEach(function(lesson, index) {
        if(currentLesson.indexOf(lesson.url) !== -1) {
          foundIndex = index
        }
      });
      return foundIndex
    },
    currentPosition: function() {
      return this.course.lessons[this.currentIndex] ? this.course.lessons[this.currentIndex].position : null
    },
    progressWidth: function() {
      return `width:${this.course.progress}%`
    },
    hasToc: function() {
      return this.params.course && (this.params.course.length > 0)
    }
  },
  watch: {
    completed: function(newVal, oldVal) {
      if(newVal && !oldVal && this.hasToc) {
        // Reload the course progress after completion
        this.$store.dispatch('userCourse/load', this.params.course)
        this.$store.dispatch('app/expandSidebar')
      }
    }
  },
  created() {
    if(this.params.course) {
      this.$store.dispatch('userCourse/load', this.params.course)
    }
  },
  methods: {
    toggleExpand() {
      this.$store.dispatch('app/toggleSidebar')
    },
    newSection(section) {
      var isNew = (this.sections.indexOf(section) === -1)
      if(isNew) { this.sections.push(section) }
      return isNew
    },
    hasNext() {
      return (this.next !== null)
    },
    showLogin() {
      this.$store.dispatch("app/showLogin")
    }
  }
}
</script>


<style>
.course-toc.course-toc--collapsed {
	 padding: 0;
}
 .course-toc.course-toc--collapsed .course-toc--content {
	 left: -330px;
}
 .course-toc .course-toc--content {
	/* expanded */
	 transition: left 0.3s;
	 width: 330px;
	 left: 0;
	 height: 100%;
}
 .course-toc .course--progress {
	 transition: width 0.3s;
}
 .course-toc .toc-lesson--completed {
	 position: relative;
}
</style>
